export default function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-hierarchy/src/hierarchy/sort.js
// module id = ../../../../d3-hierarchy/src/hierarchy/sort.js
// module chunks = 4